import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '../sp-firebase/firebase';
import type { IHistoryPrice } from '../sp-types';

// Cast import.meta to any to avoid TS complaints in environments without Vite types
const API_URL = (import.meta as any).env?.VITE_API_URL || 'http://localhost:8080';

async function waitForFirebaseUser(timeoutMs: number = 5000): Promise<User | null> {
  if (auth.currentUser) {
    return auth.currentUser;
  }

  return new Promise((resolve) => {
    let resolved = false;
    let unsubscribe: (() => void) | null = null;

    const timer = setTimeout(() => {
      if (resolved) return;
      resolved = true;
      if (unsubscribe) {
        unsubscribe();
      }
      resolve(null);
    }, timeoutMs);

    unsubscribe = onAuthStateChanged(auth, (user) => {
      if (resolved) return;
      resolved = true;
      clearTimeout(timer);
      if (unsubscribe) {
        unsubscribe();
      }
      resolve(user);
    });
  });
}

async function getAuthHeaders(): Promise<Record<string, string>> {
  const user = await waitForFirebaseUser();
  if (!user) {
    throw new Error('Not authenticated');
  }

  const token = await user.getIdToken();
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

export async function getFormulaHistory(formulaCode: string): Promise<any> {
  const headers = await getAuthHeaders();
  const url = `${API_URL}/api/v2/formulas/${encodeURIComponent(formulaCode)}/history`;
  console.log('[materialHistoryService] Fetching from:', url);

  const response = await fetch(url, {
    headers,
  });

  if (!response.ok) {
    console.error('[materialHistoryService] API error:', response.status, response.statusText);
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Failed to fetch formula history');
  }

  const data = await response.json();
  console.log('[materialHistoryService] API response:', data);
  console.log('[materialHistoryService] History array length:', data.history?.length);
  console.log('[materialHistoryService] Quote unit:', data.quoteUnit);
  
  // Return the full response object so caller can access metadata
  return data;
}
